import styled from "styled-components";
import { colorsPalettes, fonts, mixins } from "@similarweb/styles";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: 0, width: 550, minHeight: 204 },
};

export const StyledModalSubtitle = styled.div`
    margin-top: 36px;

    span {
        ${mixins.setFont({ $color: colorsPalettes.carbon["400"], $size: 16 })};
        line-height: 20px;
    }

    & b {
        font-weight: 700;
    }
`;

export const StyledModalTitle = styled.h2`
    ${mixins.setFont({
        $color: colorsPalettes.carbon["500"],
        $family: fonts.$dmSansFontFamily,
        $size: 20,
        $weight: 500,
    })};
    line-height: 24px;
    margin: 0;
`;

export const StyledModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    padding: 16px;

    & > button:last-child {
        margin-left: 8px;
    }
`;

export const StyledModalBody = styled.div`
    flex-grow: 1;
    padding: 20px 24px 8px;
`;

export const StyledModalContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;
